/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { CompannyType } from 'store/modules/concurrents_store/types';
import ParticipationModal from 'components/atoms/participation_modal';
import { getByMembership } from 'store/modules/concurrents_store/actions';
import { useDispatch } from 'react-redux';
import { Container } from './styles';

interface AdministrativeAnalysisProps {
  company: CompannyType;
}

const AdministrativeAnalysis = (props: AdministrativeAnalysisProps) => {
  const { company } = props;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    const members = company?.empresa?.quadro_socios_administradores || [];
    const names = members.map((socio: any) => socio.nome).filter(Boolean);
    dispatch(getByMembership(names));
    setShowModal(true);
  };

  return (
    <Container>
      <div className="mt-2 p-1">
        <div className="row mb-3">
          <div className="col-12">
            <div className="bg-light p-3 rounded">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>Razão social:</strong>
                  <div>{company?.empresa?.razao_social}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <strong>CNPJ:</strong>
                  <div>
                    {company?.empresa?.cnpj.replace(
                      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
                      '$1.$2.$3/$4-$5',
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-12">
            <div className="bg-light p-3 rounded">
              <div className="row">
                <div className="col-md-4 mb-3">
                  <strong>Endereço:</strong>
                  <div>{company?.empresa?.logradouro}</div>
                </div>
                <div className="col-md-4 mb-3">
                  <strong>Cidade:</strong>
                  <div>{company?.empresa?.municipio}</div>
                </div>
                <div className="col-md-4 mb-3">
                  <strong>Estado:</strong>
                  <div>{company?.empresa?.uf}</div>
                </div>
                <div className="col-md-4">
                  <strong>Telefone:</strong>
                  <div>{company?.empresa?.telefone}</div>
                </div>
                <div className="col-md-4">
                  <strong>E-mail:</strong>
                  <div>{company?.empresa?.email}</div>
                </div>
                <div className="col-md-4">
                  <strong>Situação:</strong>
                  <div>{company?.empresa?.situacao}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="bg-light p-3 rounded h-100">
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-center p-3">
                  <strong>Sócios:</strong>
                  <button type="button" className="btn btn-link" onClick={() => handleClick()}>
                    Empresas vinculadas
                  </button>
                </div>
              </div>
              <ul className="list-group list-group-flush">
                {company?.empresa?.quadro_socios_administradores.map((socio, index) => (
                  <li className="list-group-item d-flex justify-content-between" key={index}>
                    <span>{socio?.nome}</span>
                    <span className="font-weight-bold">{socio?.descricao_vinculo}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-8">
            <div className="bg-light p-3 rounded h-100">
              <strong>Segmentos:</strong>
              <ul className="list-group list-group-flush">
                {company?.empresa?.cnaes.map((segment, index) => (
                  <li className="list-group-item" key={index}>
                    {`${segment?.codigo} - ${segment?.descricao}`}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ParticipationModal show={showModal} onHide={() => setShowModal(false)} />
    </Container>
  );
};

export default AdministrativeAnalysis;
